import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date';
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
const CloneProjectStatus = _ref => {
  var _importStatus$message;
  let {
    importStatus
  } = _ref;
  const {
    t
  } = useTranslation();
  const [modalShow, setModalShow] = useState(false);
  if (!(importStatus !== null && importStatus !== void 0 && importStatus.status)) return null;
  const isError = importStatus.status === 'error';
  const dateAttempted = importStatus.updated_at ? createTimezonedDate(new Date(importStatus.updated_at), true).toCustomLocaleTimeString() : '';
  const errorMessage = isError && (_importStatus$message = importStatus.message) !== null && _importStatus$message !== void 0 && _importStatus$message.error ? importStatus.message.error : null;
  const statusMessage = () => {
    if (isError && errorMessage) {
      return /*#__PURE__*/React.createElement("span", null, "Clone attempted by ", importStatus.user, " ", dateAttempted && "at ".concat(dateAttempted), ".", /*#__PURE__*/React.createElement(Button, {
        style: {
          padding: 0,
          margin: 0
        },
        variant: "link",
        onClick: () => setModalShow(true),
        className: "ms-1"
      }, "You can check them here"));
    }
    return /*#__PURE__*/React.createElement("span", null, t('status'), ": ", t("project_deep_copier_status_".concat(importStatus.status)), " ", t('cloned_by'), ": ", importStatus.user);
  };
  const modalBody = () => /*#__PURE__*/React.createElement(React.Fragment, null, errorMessage && /*#__PURE__*/React.createElement("p", {
    className: "text-danger mb-2"
  }, errorMessage), importStatus.user && /*#__PURE__*/React.createElement("p", {
    className: "mb-1"
  }, /*#__PURE__*/React.createElement("strong", null, t('user'), ":"), " ", importStatus.user), dateAttempted && /*#__PURE__*/React.createElement("p", {
    className: "mb-0"
  }, /*#__PURE__*/React.createElement("strong", null, t('date'), ":"), " ", dateAttempted));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    show: modalShow,
    size: "lg",
    title: "Clone error",
    renderBody: modalBody,
    onHide: () => setModalShow(false),
    closeText: t('close')
  }), /*#__PURE__*/React.createElement(Row, {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(Col, null, statusMessage())));
};
export default CloneProjectStatus;